export const DeclarationItemHistoryName = 'declarationItemHistoryComponent';
